import React from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { IconList } from '../../../../../../shared/icon/icon'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { Menu, MenuItem, MenuRestore } from '../../../../../../shared/menu/menu'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { useApiListAppStore } from '../../../../../../api-new/state/config'
import { IconPurge } from '../../../../../../shared/icon/icon'
import { useRoleSysApp } from '../../../../../../role/hook/role-sys'
import { TableAgClient } from '../../../../../../shared/table-builder/table-ag-client'
import { ColumnText, ColumnMenu } from '../../../../../../shared/table-builder/table-columns'
import { recycleErrorMessage } from '../../../../../../shared/error/server-message'
import { ErrorReference } from '../../../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../../../shared/error/use-error-line'

export const AppStoreRecycle = () => {
  const { appID } = useParamsInt()

  const apiListAppStore = useApiListAppStore()

  const roleSysApp = useRoleSysApp()

  const [error, failure, setError] = useErrorLine()

  const handleReady = () => apiListAppStore.get('deleted')
  const handleDestroyed = () => apiListAppStore.init()

  const handleRestore = async id => {
    setError(null)
    try {
      await apiListAppStore.put(`${id}/restore`)
    } catch (err) {
      setError(recycleErrorMessage(err, 'That app store was already removed.'), err)
    }
    await apiListAppStore.get('deleted')
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="Recycle bin">
        <CardFullHeightScrollY title="recycle bin">
          {error &&
            <p className="text-danger" role="alert">
              {error}
            </p>}
          {error && <ErrorReference error={failure} className="mb-3" />}
          <TableAgClient apiList={apiListAppStore} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="name" />
            <ColumnText field="key" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuRestore onClick={() => handleRestore(row.id)} show={roleSysApp.accessDelete} />
                  <MenuItem Icon={IconPurge} text="purge" to={`/admin/app/edit/${appID}/store/recycle/purge/${row.id}`} show={roleSysApp.accessPurge} pin />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
